/**
 * @private
 */
function appendForwardSlash(url) {
  if (url.length === 0 || url[url.length - 1] !== "/") {
    url = "".concat(url, "/");
  }
  return url;
}
export default appendForwardSlash;